import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faSearch, faTimes, faUpload } from '@fortawesome/free-solid-svg-icons'

export const setupFontAwesomeIcons = () => {
  library.add(faPlus, faSearch, faTimes, faUpload)
}
